<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('inversions')">Inversión</inertia-link>
      <span class="text-white font-medium">/Crear</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-4xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/5">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha inicio:</label>
           <datetime format="MM/DD/YYYY h:i:s" :class="bg-inexgray"  v-model="form.inicio" width="300px" name='dob'>
           </datetime>          
          </div>
          <div  class="container pr-6 pb-8 w-full lg:w-3/5">
            <label style="color: white; font-weight: 700;" class="form-label" >Cliente:</label>
            <v-select style="color: white; background-color: inexinput;" v-model="form.cliente" :options="contactss" @search="onSearch" value="id" label="nombres">
            </v-select>
          </div>   
          <text-input v-model="form.monto" :error="form.errors.monto" class="pr-6 pb-8 w-full lg:w-1/5" label="Monto $" required/>
          <div class="pr-6 pb-8 w-full lg:w-1/5">
           <label style="color: white; font-weight: 700;" class="form-label" >Fecha final:</label>
           <datetime format="MM/DD/YYYY h:i:s" v-model="form.final" width="300px" name='dob'>
           </datetime>          
          </div>
          <div  class="container pr-6 pb-8 w-full lg:w-2/5">
            <label style="color: white; font-weight: 700;" class="form-label" >Tipo:</label>
            <v-select style="color: white; background-color: inexinput;" v-model="form.tipo" :options="tiposs" value="id" label="nombres">
            </v-select>
          </div>   
        <text-input v-model="form.id_inversion" :error="form.errors.id_inversion" class="pr-6 pb-8 w-full lg:w-2/5" label="Inversion ID" required/>
        <text-input v-model="form.porcentaje" :error="form.errors.porcentaje" class="pr-6 pb-8 w-full lg:w-2/5" label="Porcentaje" required/>
        <text-input v-model="form.tiempo" :error="form.errors.tiempo" class="pr-6 pb-8 w-full lg:w-2/5" label="Tiempo Inv." required/>

    

      </div>
      <br><br>
        <br><br>
        <br><br>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Agregar Inversión</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import LoadingButton from '@/Shared/LoadingButton'
import axios from "axios";
import datetime from 'vuejs-datetimepicker';


export default {
  metaInfo: { title: 'Agregar Inversión' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    datetime,
    vSelect
  },
  layout: Layout,
  props: {
    tipos: Array,
    contacts: Array,

  },
  remember: 'form',
  data() {
    return {
      contactss: this.contacts,
      tiposs: this.tipos,
      form: this.$inertia.form({
        inicio: null,
        cliente: null,
        final: null,
        id_inversion: null,
        tipo: null,
        monto: null,
        porcentaje: null,
        tiempo: null,
        ganado: null,
        tipo: 'Simple',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('inversions.store'))
    },
    codigo(value) {
      try {
        axios.get('/simuladorsContact?buscar=' + value,{
   headers: {
    "Content-Type": "application/json"
        }
      }).then(res => {
        this.contactss=res.data;
      }).catch(err => {
        console.log(err.response);
      });
      } catch (error) {
        console.log(error);
      }
    },
    onSearch(query) {
      if(query.length==0)
    {
      this.contactss=this.contacts;
    }
    else{
      this.search = query
      this.codigo(query);
    }

    },
  },
}
</script>
